import React, { useState, useEffect } from "react"
import MetaTags from "react-meta-tags"
import { Link, useLocation, useHistory } from "react-router-dom"
import {
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  Label,
  Row,
  Card,
  CardImg,
  CardTitle,
  Modal,
  Collapse,
} from "reactstrap"
import { Carousel } from "react-responsive-carousel"
import "react-responsive-carousel/lib/styles/carousel.min.css"
import * as url from "helpers/url_helper"
import SweetAlert from "react-bootstrap-sweetalert"
import moment from "moment"
import { cardSize } from "helpers/constants_helper"

//i18n
import PropTypes from "prop-types"
import { withTranslation } from "react-i18next"

// import images
import logodark from "../../assets/images/logo-dark.png"
import logolight from "../../assets/images/logo-light.png"
import bgImage from "assets/images/ugifts/loginbg.png"
import bgProfile from "assets/images/ugifts/profile_bg.png"
import iconCompleted from "assets/images/ugifts/icons/order/completed.png"
import iconIncomplete from "assets/images/ugifts/icons/order/incomplete.png"
import placeholderCamera from "assets/images/ugifts/dummyCard/placeholder_camera.png"
import viewCard from "assets/images/ugifts/view_card.png"

import { Button } from "@material-ui/core"

function useQuery() {
  return new URLSearchParams(useLocation().search)
}

function hexToBytes(hex) {
  const bytes = new Uint8Array(hex.length / 2)
  for (let i = 0; i !== bytes.length; i++) {
    bytes[i] = parseInt(hex.substr(i * 2, 2), 16)
  }
  return bytes
}

const OrderHistoryDetails = props => {
  const query = useQuery()
  const history = useHistory()

  const [token, setToken] = useState(null)
  const [uid, setUid] = useState(null)
  const [listType, setListType] = useState("list_friend")
  const [quantity, setQuantity] = useState(0)
  const [oid, setOid] = useState(null)
  const [opened, setOpened] = useState(false)

  useEffect(() => {
    if (localStorage.getItem("authAPI")) {
      const obj = JSON.parse(localStorage.getItem("authAPI"))
      console.log(
        "storage",
        obj.api_token_expiry + " / " + Math.floor(Date.now() / 1000)
      )
      if (obj.api_token_expiry < Math.floor(Date.now() / 1000)) {
        getToken()
      } else {
        setToken(obj)
      }
    } else {
      getToken()
    }

    if (localStorage.getItem("authUser")) {
      const obj = JSON.parse(localStorage.getItem("authUser"))
      setUid(obj.member_id)
      console.log(obj)
    }

    if (query.get("id")) {
      setOid(query.get("id"))
    }

    if (localStorage.getItem("I18N_LANGUAGE")) {
      setLanguage(localStorage.getItem("I18N_LANGUAGE"))
    }
  }, [])

  const getToken = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "get_api_token")
    urlencoded.append("source", "web")
    urlencoded.append("api_key", process.env.REACT_APP_APIKEY)

    const requestOptions = {
      method: "POST",
      body: urlencoded,
    }

    console.log("Request token", urlencoded.toString())

    const response = await fetch(url.UGIFT_STAGING_POST_AUTH, requestOptions)
    const postresponse = await response.json()

    console.log(response.status, postresponse.message)

    if (response.status == 200 && postresponse.success) {
      setToken(postresponse)
      localStorage.setItem("authAPI", JSON.stringify(postresponse))
      console.log(response.status, token)
    } else {
      // seterror_alert(true)
    }
  }

  useEffect(() => {
    if (token != null) {
      getUserProfile()
      getOrderData()
      getFriendList()
      getMusicList()
      console.log("use effect")
    }
  }, [token])

  const [userData, setUserData] = useState(null)
  const getUserProfile = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "detail_profile")
    urlencoded.append("member_id", uid)

    const requestOptions = {
      method: "POST",
      // mode: "no-cors",
      headers: {
        // "Content-Type": "application/json",
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request category", urlencoded.toString())

    const response = await fetch(
      url.UGIFT_STAGING_PROFILE,
      // "http://47.241.176.8/api/external/auth/",
      requestOptions
    )
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200) {
      // history.push("/tables-applicationtable")
      setUserData(postresponse.table)
    } else {
      // seterror_alert(true)
    }
  }

  const [orderData, setOrderData] = useState(null)
  const [giftcardId, setGiftcardId] = useState(null)
  const [giftEditableData, setGiftEditableData] = useState(null)
  const getOrderData = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "detail_order")
    urlencoded.append("order_id", oid)

    const requestOptions = {
      method: "POST",
      // mode: "no-cors",
      headers: {
        // "Content-Type": "application/json",
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request order", urlencoded.toString())

    const response = await fetch(
      url.UGIFT_STAGING_ORDER,
      // "http://47.241.176.8/api/external/auth/",
      requestOptions
    )
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200) {
      // history.push("/tables-applicationtable")
      setOrderData(postresponse.table)
      if (postresponse.table.giftcard_id) {
        setGiftcardId(postresponse.table.giftcard_id)
      }
    } else {
      // seterror_alert(true)
    }
  }

  const [musicData, setMusicData] = useState(null)
  const getMusicList = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "list_music")
    urlencoded.append("order_by", "asc")
    // urlencoded.append("giftcard_id", giftcardId)

    const requestOptions = {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request giftcard music", urlencoded.toString())

    const response = await fetch(url.UGIFT_STAGING_GIFT, requestOptions)
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200) {
      // history.push("/tables-applicationtable")
      setMusicData(postresponse.table)
    } else {
      // seterror_alert(true)
    }
  }

  useEffect(() => {
    if (token != null) getGiftList()
  }, [giftcardId])

  useEffect(() => {
    if (orderData) {
      var calculate = 0
      orderData.products.forEach(product => {
        calculate + parseInt(product.quantity)
      })
      setQuantity(calculate)
      if (orderData.giftcard_edit_parameter != "") {
        const download = JSON.parse(orderData.giftcard_edit_parameter)
        download
          .filter(data => {
            return data.type == "message" || data.type == "text"
          })
          .forEach(data => {
            data["content"] = new TextDecoder().decode(
              hexToBytes(data["content"])
            )
          })
        setGiftEditableData(download)
        console.log(download)
        // setGiftEditableData(JSON.parse(orderData.giftcard_edit_parameter))
        // console.log(JSON.parse(orderData.giftcard_edit_parameter))
      }
    }
  }, [orderData])

  const [giftData, setGiftData] = useState(null)
  const getGiftList = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "detail_giftcard")
    // urlencoded.append("order_by", sortType)
    urlencoded.append("giftcard_id", giftcardId)

    const requestOptions = {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request giftcard product", urlencoded.toString())

    const response = await fetch(url.UGIFT_STAGING_GIFT, requestOptions)
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200) {
      // history.push("/tables-applicationtable")
      setGiftData(postresponse.table)
    } else {
      // seterror_alert(true)
    }
  }

  const onClickCancelOrder = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "cancel_order")
    urlencoded.append("order_id", oid)
    urlencoded.append("member_id", uid)

    const requestOptions = {
      method: "POST",
      // mode: "no-cors",
      headers: {
        // "Content-Type": "application/json",
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request cancel order", urlencoded.toString())

    const response = await fetch(
      url.UGIFT_STAGING_ORDER,
      // "http://47.241.176.8/api/external/auth/",
      requestOptions
    )
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200) {
      // history.push("/tables-applicationtable")
      // setBasketData(postresponse.table)
      if (postresponse.success) {
        setsuccess_dlg_cancel(true)
        setdynamic_title("Order Cancelled")
        setdynamic_description(postresponse.message)
      } else {
        seterror_alert(true)
        setdynamic_title(props.t("Order Cancellation Failed"))
        setdynamic_description(postresponse.message)
      }
    } else {
      seterror_alert(true)
      setdynamic_title(props.t("Order Cancellation Failed"))
      setdynamic_description(postresponse.message)
    }
  }

  // const onClickReserveOrder = async () => {
  //   var urlencoded = new URLSearchParams()
  //   urlencoded.append("option", "reserve_order")
  //   urlencoded.append("member_id", uid)
  //   urlencoded.append("order_id", oid)

  //   const requestOptions = {
  //     method: "POST",
  //     // mode: "no-cors",
  //     headers: {
  //       // "Content-Type": "application/json",
  //       Authorization: "Bearer " + token.api_token,
  //     },
  //     body: urlencoded,
  //   }

  //   console.log("Request reserve order", urlencoded.toString())

  //   const response = await fetch(
  //     url.UGIFT_STAGING_ORDER,
  //     // "http://47.241.176.8/api/external/auth/",
  //     requestOptions
  //   )
  //   const postresponse = await response.json()
  //   // response.body
  //   // setPostResponse(postresponse)
  //   console.log(response.status, postresponse)

  //   if (response.status == 200) {
  //     // history.push("/tables-applicationtable")
  //     // setUserData(postresponse.table)
  //     if (postresponse.success) {
  //       // setsuccess_dlg(true)
  //       // setdynamic_title("Pay order success")
  //       // setdynamic_description(postresponse.message)
  //       onClickPayOrder()
  //     } else {
  //       seterror_alert(true)
  //       setdynamic_title("Reserve Order Failed")
  //       setdynamic_description(
  //         postresponse.message + "\n\n" + postresponse.insufficient_stock
  //       )
  //     }
  //   } else {
  //     seterror_alert(true)
  //     setdynamic_title("Reserve Order Failed")
  //     setdynamic_description(postresponse.message)
  //   }
  // }

  // const onClickPayOrder = async () => {
  //   var urlencoded = new URLSearchParams()
  //   urlencoded.append("option", "pay_order")
  //   urlencoded.append("member_id", uid)
  //   urlencoded.append("order_id", oid)
  //   urlencoded.append("payment_status", "paid")

  //   const requestOptions = {
  //     method: "POST",
  //     // mode: "no-cors",
  //     headers: {
  //       // "Content-Type": "application/json",
  //       Authorization: "Bearer " + token.api_token,
  //     },
  //     body: urlencoded,
  //   }

  //   console.log("Request pay order", urlencoded.toString())

  //   const response = await fetch(
  //     url.UGIFT_STAGING_ORDER,
  //     // "http://47.241.176.8/api/external/auth/",
  //     requestOptions
  //   )
  //   const postresponse = await response.json()
  //   // response.body
  //   // setPostResponse(postresponse)
  //   console.log(response.status, postresponse)

  //   if (response.status == 200) {
  //     // history.push("/tables-applicationtable")
  //     // setUserData(postresponse.table)
  //     if (postresponse.success) {
  //       setsuccess_dlg(true)
  //       setdynamic_title("Pay order success")
  //       setdynamic_description(postresponse.message)
  //     }
  //   } else {
  //     seterror_alert(true)
  //     setdynamic_title("Pay Order Failed")
  //     setdynamic_description(postresponse.message)
  //   }
  // }

  const onClickRequestCashier = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "get_cashier_url")
    urlencoded.append("order_id", oid)

    const requestOptions = {
      method: "POST",
      // mode: "no-cors",
      headers: {
        // "Content-Type": "application/json",
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request cashier url", urlencoded.toString())

    const response = await fetch(
      url.UGIFT_STAGING_ORDER,
      // "http://47.241.176.8/api/external/auth/",
      requestOptions
    )
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200) {
      // history.push("/tables-applicationtable")
      // setUserData(postresponse.table)
      if (postresponse.success) {
        window.open(postresponse.cashier_url, "_self")
      } else {
        seterror_alert(true)
        setdynamic_title(props.t("Get Cashier Failed"))
        setdynamic_description(postresponse.message)
      }
    } else {
      seterror_alert(true)
      setdynamic_title(props.t("Get Cashier Failed"))
      setdynamic_description(postresponse.message)
    }
  }

  const [searchData, setSearchData] = useState("")

  function onSubmitSearchField(e) {
    e.preventDefault()
    getFriendList()
  }

  function onChangeSearchField(e) {
    setSearchData(e.target.value)
  }

  const [friendData, setFriendData] = useState(null)
  const getFriendList = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", listType)
    urlencoded.append("member_id", uid)
    if (searchData) urlencoded.append("filter_by_name", searchData)

    const requestOptions = {
      method: "POST",
      // mode: "no-cors",
      headers: {
        // "Content-Type": "application/json",
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request friend list", urlencoded.toString())

    const response = await fetch(
      url.UGIFT_STAGING_PROFILE,
      // "http://47.241.176.8/api/external/auth/",
      requestOptions
    )
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200) {
      // history.push("/tables-applicationtable")
      setFriendData(postresponse.table)
    } else {
      // seterror_alert(true)
    }
  }

  const [modal_sendToFriend, setmodal_sendToFriend] = useState(false)

  function tog_sendToFriend() {
    setmodal_sendToFriend(!modal_sendToFriend)
    setShareCodeMessage("Social Share")
    removeBodyCss()
  }

  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }

  const onClickSendOrder = async recipient_id => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "send_order")
    urlencoded.append("member_id", uid)
    urlencoded.append("order_id", oid)
    urlencoded.append("recipient_id", recipient_id)

    const requestOptions = {
      method: "POST",
      // mode: "no-cors",
      headers: {
        // "Content-Type": "application/json",
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request send order", urlencoded.toString())

    const response = await fetch(
      url.UGIFT_STAGING_ORDER,
      // "http://47.241.176.8/api/external/auth/",
      requestOptions
    )
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200) {
      // history.push("/tables-applicationtable")
      // setUserData(postresponse.table)
      if (postresponse.success) {
        setsuccess_dlg_noaction(true)
        setdynamic_title(props.t("Send order success"))
        setdynamic_description(postresponse.message)
        getOrderData()
      }
    } else {
      seterror_alert(true)
      setdynamic_title(props.t("Send Order Failed"))
      setdynamic_description(postresponse.message)
    }
  }

  const [shareCodeMessage, setShareCodeMessage] = useState(
    props.t("Social Share")
  )
  const handleCopy = input => {
    const textField = document.createElement("textarea")
    textField.innerText = input
    document.body.appendChild(textField)
    textField.select()
    document.execCommand("copy")
    textField.remove()
    setShareCodeMessage(props.t("Copied"))
  }

  const [success_dlg, setsuccess_dlg] = useState(false)
  const [success_dlg_cancel, setsuccess_dlg_cancel] = useState(false)
  const [success_dlg_noaction, setsuccess_dlg_noaction] = useState(false)
  const [error_alert, seterror_alert] = useState(false)
  const [dynamic_title, setdynamic_title] = useState("")
  const [dynamic_description, setdynamic_description] = useState("")

  const [confirm_alert, setconfirm_alert] = useState(false)

  const [language, setLanguage] = useState("eng")

  const multiLanguageHandler = data => {
    switch (language) {
      case "eng":
        return data.en
      case "cn":
        return data.cn ? data.cn : data.en
      case "jp":
        return data.jp ? data.jp : data.en
      default:
        return data.en
    }
  }

  return (
    <React.Fragment>
      <div>
        <MetaTags>
          <title>Ugift</title>
        </MetaTags>
        <Container fluid className="p-0">
          <Row className="g-0">
            {success_dlg_noaction ? (
              <SweetAlert
                success
                title={dynamic_title}
                onConfirm={() => {
                  setsuccess_dlg_noaction(false)
                }}
              >
                {dynamic_description}
              </SweetAlert>
            ) : null}
            {success_dlg ? (
              <SweetAlert
                success
                title={dynamic_title}
                onConfirm={() => {
                  history.push("/payment-status?id=" + oid)
                }}
              >
                {dynamic_description}
              </SweetAlert>
            ) : null}
            {success_dlg_cancel ? (
              <SweetAlert
                success
                title={dynamic_title}
                onConfirm={() => {
                  history.push("/profile")
                }}
              >
                {dynamic_description}
              </SweetAlert>
            ) : null}
            {error_alert ? (
              <SweetAlert
                title={dynamic_title}
                danger
                onConfirm={() => {
                  seterror_alert(false)
                }}
              >
                {dynamic_description}
              </SweetAlert>
            ) : null}
            {confirm_alert ? (
              <SweetAlert
                title={props.t("Are you sure you want to cancel this order?")} //{props.t("Are you sure?")}
                warning
                showCancel
                confirmBtnText={props.t("Yes")}
                confirmBtnBsStyle="primary"
                cancelBtnText={props.t("No")}
                cancelBtnBsStyle="danger"
                onConfirm={() => {
                  setconfirm_alert(false)
                  onClickCancelOrder()
                }}
                onCancel={() => setconfirm_alert(false)}
              >
                {/* {"Mark used confirmation"} */}
              </SweetAlert>
            ) : null}
            <Col
              xl={6}
              className="mx-auto"
              style={{
                maxWidth: "480px",
                backgroundColor: "white",
                // backgroundImage: `url(${bgImage})`,
                // backgroundSize: "cover",
              }}
            >
              {/* <img
                src={bgImage}
                alt=""
                style={{
                  position: "absolute",
                  objectFit: "contain",
                  maxWidth: "480px",
                }}
              /> */}
              <div
                className="auth-full-page-content"
                style={{
                  minHeight: "100vh",
                  paddingTop: "56px",
                  backgroundColor: "#F5F5F5",
                  paddingBottom: "92px",
                }}
              >
                <div className="w-100">
                  <div className="d-flex flex-column h-100">
                    <Row
                      className="m-0 w-100"
                      style={{
                        height: "56px",
                        backgroundColor: "#009FE2",
                        position: "fixed",
                        top: 0,
                        zIndex: 1030,
                        maxWidth: "480px",
                      }}
                    >
                      <Col xs={2} className="ps-0">
                        {/* <Link to="/categories"> */}
                        <Button
                          className="h-100 m-0"
                          onClick={() => {
                            history.goBack()
                          }}
                        >
                          <i className="bx bx-arrow-back align-middle font-size-20 text-white" />
                        </Button>
                        {/* </Link> */}
                      </Col>
                      <Col xs={8} className="align-self-center">
                        <p className="h-100 text-white font-size-15 my-auto text-center">
                          {orderData &&
                            orderData.payment_status == "Pending" &&
                            "Pay Now"}
                        </p>
                      </Col>
                      <Col xs={2} className="pe-0">
                        {/* <Link to="#">
                          <Button className="h-100 m-0">
                            <i className="bx bx-basket align-middle font-size-28 text-white" />
                          </Button>
                        </Link> */}
                      </Col>
                    </Row>
                    {giftData && giftcardId != "0" && (
                      <Row className="p-3">
                        <Col>
                          <span
                            className="font-size-20 text-dark"
                            style={{ fontWeight: 500 }}
                          >
                            {props.t("Gift Card")}
                          </span>
                        </Col>
                      </Row>
                    )}
                    {orderData && giftData && giftcardId != "0" && (
                      <Row>
                        <Col>
                          {/* <Card
                            className="mb-0 p-3 shadow-none"
                            style={{
                              borderRadius: "0px",
                              // width: "160px",
                              // height: "196px",
                              backgroundColor: "white",
                            }}
                          >
                            <CardImg
                              top
                              className="img-fluid"
                              src={
                                orderData.order_status == "Gifted" &&
                                orderData.member_id != uid
                                  ? opened
                                    ? giftData.image
                                    : viewCard
                                  : giftData.image
                              }
                              alt=""
                              style={{
                                aspectRatio: "3/2",
                                objectFit: "scale-down",
                                borderRadius: "14px",
                              }}
                              onClick={() => {
                                setOpened(true)
                              }}
                            />
                          </Card> */}
                          <Card
                            className="mb-3 p-3"
                            style={{
                              borderRadius: "0px",
                              // width: "160px",
                              // height: "196px",
                              backgroundColor: "white",
                            }}
                          >
                            <Card className="mb-0">
                              {giftData && (
                                <CardImg
                                  top
                                  className="img-fluid"
                                  src={giftData.image}
                                  alt=""
                                  style={{
                                    aspectRatio: "3/2",
                                    // objectFit: "cover",
                                    borderRadius: "14px",
                                    zIndex: 500,
                                  }}
                                />
                              )}
                              {giftEditableData &&
                                giftEditableData
                                  .filter(data => {
                                    return data.type == "text"
                                  })
                                  .map((data, index) => (
                                    // <Input
                                    //   type="text"
                                    //   className="form-control font-size-15"
                                    //   id={"textInput-" + data.key}
                                    //   name={data.key}
                                    //   placeholder={data.placeholder}
                                    //   value={data.content}
                                    //   style={{
                                    //     borderRadius: "4px",
                                    //     border: "none",
                                    //     background: "none",
                                    //     position: "absolute",
                                    //     top: `calc(100% * ${data.ypos / 800})`,
                                    //     left: `calc(100% * ${data.xpos / 1200})`,
                                    //     width: `calc(100% * ${
                                    //       data.width / 1200
                                    //     })`,
                                    //     height: `calc(100% * ${
                                    //       data.height / 800
                                    //     })`,
                                    //     zIndex: 502,
                                    //   }}
                                    // />
                                    <span
                                      type="text"
                                      className="form-control font-size-15"
                                      id={"textInput-" + data.key}
                                      name={data.key}
                                      placeholder={data.placeholder}
                                      value={data.content}
                                      style={{
                                        borderRadius: "4px",
                                        border: "none",
                                        background: "none",
                                        position: "absolute",
                                        top: `calc(100% * ${
                                          data.ypos / cardSize.height
                                        })`,
                                        left: `calc(100% * ${
                                          data.xpos / cardSize.width
                                        })`,
                                        width: `calc(100% * ${
                                          data.width / cardSize.width
                                        })`,
                                        height: `calc(100% * ${
                                          data.height / cardSize.height
                                        })`,
                                        zIndex: 502,
                                      }}
                                    >
                                      {data.content}
                                    </span>
                                  ))}

                              {giftEditableData &&
                                giftEditableData
                                  .filter(data => {
                                    return data.type == "image"
                                  })
                                  .map(
                                    (data, index) =>
                                      data.content && (
                                        <div>
                                          <img
                                            src={data.content}
                                            id={"imgPreview-" + data.key}
                                            name={data.key}
                                            style={{
                                              position: "absolute",
                                              top: `calc(100% * ${
                                                data.ypos / cardSize.height
                                              })`,
                                              left: `calc(100% * ${
                                                data.xpos / cardSize.width
                                              })`,
                                              width: `calc(100% * ${
                                                data.width / cardSize.width
                                              })`,
                                              height: `calc(100% * ${
                                                data.height / cardSize.height
                                              })`,
                                              // objectFit: "scale-down",
                                              objectFit: "cover",
                                              zIndex: 499,
                                            }}
                                          />
                                        </div>
                                      )
                                  )}
                            </Card>
                          </Card>
                        </Col>
                      </Row>
                    )}
                    {giftEditableData &&
                      giftEditableData
                        .filter(data => {
                          return data.type == "message"
                        })
                        .map(
                          (data, index) =>
                            data.content != "" && (
                              <div>
                                <Row className="p-3">
                                  <Col>
                                    <span
                                      className="font-size-20 text-dark"
                                      style={{ fontWeight: 500 }}
                                    >
                                      {props.t("Message")}
                                    </span>
                                  </Col>
                                </Row>
                                <Row className="mx-0 mb-3">
                                  <Col className="px-3">
                                    <Card
                                      className="mb-0 shadow-none p-3"
                                      style={{
                                        // borderRadius: "0px",
                                        backgroundColor: "white",
                                      }}
                                    >
                                      <Row className="">
                                        <Col>
                                          <span className="font-size-15 text-dark">
                                            {data.content}
                                          </span>
                                        </Col>
                                      </Row>
                                    </Card>
                                  </Col>
                                </Row>
                              </div>
                            )
                        )}
                    {giftEditableData &&
                      musicData &&
                      giftEditableData
                        .filter(data => {
                          return data.type == "music"
                        })
                        .map(
                          (data, index) =>
                            data.content != "" && (
                              <Row className="m-0">
                                <Col>
                                  <Row className="px-3">
                                    <button
                                      className="btn btn-outline-light mt-0 font-size-18 bg-white text-dark"
                                      // onClick={tog_song}
                                    >
                                      <span className="align-middle">
                                        <i className="bx bx-volume-full align-middle font-size-22 me-2" />{" "}
                                        {data.content &&
                                          musicData.filter(
                                            value => value.id == data.content
                                          ).length > 0 &&
                                          musicData.filter(
                                            value => value.id == data.content
                                          )[0].name}
                                      </span>
                                    </button>
                                  </Row>
                                </Col>
                              </Row>
                            )
                        )}
                    {orderData && (
                      <Row className="p-3">
                        <Col>
                          <span
                            className="font-size-20 text-dark"
                            style={{ fontWeight: 500 }}
                          >
                            {props.t("Order Status")}
                          </span>
                        </Col>
                      </Row>
                    )}
                    {orderData && (
                      <Card
                        className="mb-0 p-3 shadow-none"
                        style={{
                          borderRadius: "0px",
                          // width: "160px",
                          // height: "196px",
                          backgroundColor: "white",
                        }}
                      >
                        <Row className="mb-3">
                          <Col>
                            <img
                              src={iconCompleted}
                              className="avatar-sm me-3"
                              alt=""
                              style={{
                                // borderRadius: "8px",
                                maxWidth: "24px",
                                maxHeight: "24px",
                              }}
                            />
                            <span className="font-size-14">{"Order ID"}</span>
                          </Col>
                          <Col className="text-end">
                            <span
                              className="font-size-14"
                              style={{ fontWeight: 500 }}
                            >
                              {orderData.order_no}
                            </span>
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Col>
                            <img
                              src={iconCompleted}
                              className="avatar-sm me-3"
                              alt=""
                              style={{
                                // borderRadius: "8px",
                                maxWidth: "24px",
                                maxHeight: "24px",
                              }}
                            />
                            <span className="font-size-14">
                              {props.t("Order date")}
                            </span>
                          </Col>
                          <Col className="text-end">
                            <span
                              className="font-size-14"
                              style={{ fontWeight: 500 }}
                            >
                              {moment(
                                orderData.created_date,
                                "DD/MM/YYYY HH:mm:ss"
                              ).format("D MMM YYYY HH:mm:ss")}
                            </span>
                          </Col>
                        </Row>
                        {(orderData.order_status != "Gifted" ||
                          orderData.member_id == uid) && (
                          <Row className="mb-3">
                            <Col>
                              {/* {orderData.payment_status == "Pending" && (
                                <img
                                  src={iconIncomplete}
                                  className="avatar-sm me-3"
                                  alt=""
                                  style={{
                                    // borderRadius: "8px",
                                    maxWidth: "24px",
                                    maxHeight: "24px",
                                  }}
                                />
                              )} */}
                              {orderData.payment_status == "Paid" ? (
                                <img
                                  src={iconCompleted}
                                  className="avatar-sm me-3"
                                  alt=""
                                  style={{
                                    // borderRadius: "8px",
                                    maxWidth: "24px",
                                    maxHeight: "24px",
                                  }}
                                />
                              ) : (
                                <img
                                  src={iconIncomplete}
                                  className="avatar-sm me-3"
                                  alt=""
                                  style={{
                                    // borderRadius: "8px",
                                    maxWidth: "24px",
                                    maxHeight: "24px",
                                  }}
                                />
                              )}
                              <span className="font-size-14">{"Paid on"}</span>
                            </Col>
                            <Col className="text-end">
                              {(orderData.payment_status == "Pending" ||
                                orderData.payment_status ==
                                  "Campaign Redemption") && (
                                <span
                                  className="font-size-14"
                                  style={{ fontWeight: 500 }}
                                >
                                  {"-"}
                                </span>
                              )}
                              {orderData.payment_status == "Paid" && (
                                <span
                                  className="font-size-14"
                                  style={{ fontWeight: 500 }}
                                >
                                  {moment(
                                    orderData.paid_date,
                                    "DD/MM/YYYY HH:mm:ss"
                                  ).format("D MMM YYYY HH:mm:ss")}
                                </span>
                              )}
                            </Col>
                          </Row>
                        )}
                        {(orderData.order_status != "Gifted" ||
                          orderData.member_id == uid) && (
                          <Row className="mb-3">
                            <Col>
                              {(orderData.payment_status == "Pending" ||
                                orderData.payment_status ==
                                  "Campaign Redemption") && (
                                <img
                                  src={iconIncomplete}
                                  className="avatar-sm me-3"
                                  alt=""
                                  style={{
                                    // borderRadius: "8px",
                                    maxWidth: "24px",
                                    maxHeight: "24px",
                                  }}
                                />
                              )}
                              {orderData.payment_status == "Paid" &&
                                (orderData.recipient_id != "0" ? (
                                  <img
                                    src={iconCompleted}
                                    className="avatar-sm me-3"
                                    alt=""
                                    style={{
                                      // borderRadius: "8px",
                                      maxWidth: "24px",
                                      maxHeight: "24px",
                                    }}
                                  />
                                ) : (
                                  <img
                                    src={iconIncomplete}
                                    className="avatar-sm me-3"
                                    alt=""
                                    style={{
                                      // borderRadius: "8px",
                                      maxWidth: "24px",
                                      maxHeight: "24px",
                                    }}
                                  />
                                ))}
                              <span className="font-size-14">{"Sent to"}</span>
                            </Col>
                            <Col className="text-end">
                              {(orderData.payment_status == "Pending" ||
                                orderData.payment_status ==
                                  "Campaign Redemption") && (
                                <span
                                  className="font-size-14"
                                  style={{ fontWeight: 500 }}
                                >
                                  {"-"}
                                </span>
                              )}
                              {orderData.payment_status == "Paid" &&
                                (orderData.recipient_id != "0" ? (
                                  <span
                                    className="font-size-14"
                                    style={{ fontWeight: 500 }}
                                  >
                                    {orderData.recipient_name}
                                  </span>
                                ) : (
                                  <span
                                    className="font-size-14"
                                    style={{ fontWeight: 500 }}
                                  >
                                    {"-"}
                                  </span>
                                ))}
                            </Col>
                          </Row>
                        )}
                        {(orderData.order_status != "Gifted" ||
                          orderData.member_id == uid) && (
                          <Row className="">
                            <Col>
                              {(orderData.payment_status == "Pending" ||
                                orderData.payment_status ==
                                  "Campaign Redemption") && (
                                <img
                                  src={iconIncomplete}
                                  className="avatar-sm me-3"
                                  alt=""
                                  style={{
                                    // borderRadius: "8px",
                                    maxWidth: "24px",
                                    maxHeight: "24px",
                                  }}
                                />
                              )}
                              {orderData.payment_status == "Paid" &&
                                (orderData.received_date != "" ? (
                                  <img
                                    src={iconCompleted}
                                    className="avatar-sm me-3"
                                    alt=""
                                    style={{
                                      // borderRadius: "8px",
                                      maxWidth: "24px",
                                      maxHeight: "24px",
                                    }}
                                  />
                                ) : (
                                  <img
                                    src={iconIncomplete}
                                    className="avatar-sm me-3"
                                    alt=""
                                    style={{
                                      // borderRadius: "8px",
                                      maxWidth: "24px",
                                      maxHeight: "24px",
                                    }}
                                  />
                                ))}
                              <span className="font-size-14">
                                {props.t("Redeem")}
                              </span>
                            </Col>
                            <Col className="text-end">
                              {(orderData.payment_status == "Pending" ||
                                orderData.payment_status ==
                                  "Campaign Redemption") && (
                                <span
                                  className="font-size-14"
                                  style={{ fontWeight: 500 }}
                                >
                                  {"-"}
                                </span>
                              )}
                              {orderData.payment_status == "Paid" &&
                                (orderData.received_date != "" ? (
                                  <span
                                    className="font-size-14"
                                    style={{ fontWeight: 500 }}
                                  >
                                    {moment(
                                      orderData.received_date,
                                      "DD/MM/YYYY HH:mm:ss"
                                    ).format("D MMM YYYY HH:mm:ss")}
                                  </span>
                                ) : (
                                  <span
                                    className="font-size-14"
                                    style={{ fontWeight: 500 }}
                                  >
                                    {"-"}
                                  </span>
                                ))}
                            </Col>
                          </Row>
                        )}
                        {orderData.order_status == "Gifted" &&
                          orderData.member_id != uid && (
                            <Row className="">
                              <Col>
                                <img
                                  src={iconCompleted}
                                  className="avatar-sm me-3"
                                  alt=""
                                  style={{
                                    // borderRadius: "8px",
                                    maxWidth: "24px",
                                    maxHeight: "24px",
                                  }}
                                />
                                <span className="font-size-14">
                                  {props.t("Received from")}
                                </span>
                              </Col>
                              <Col className="text-end">
                                <span
                                  className="font-size-14"
                                  style={{ fontWeight: 500 }}
                                >
                                  {orderData.member_name}
                                </span>
                              </Col>
                            </Row>
                          )}
                      </Card>
                    )}
                    {orderData && (
                      <Row className="p-3">
                        <Col>
                          <span
                            className="font-size-20 text-dark"
                            style={{ fontWeight: 500 }}
                          >
                            {props.t("Order Summary")}
                          </span>
                        </Col>
                      </Row>
                    )}
                    <Row>
                      <Col>
                        {orderData &&
                          orderData.products.map((data, index) => (
                            <Card
                              className="mb-0 p-3 shadow-none"
                              style={{
                                borderRadius: "0px",
                                // width: "160px",
                                // height: "196px",
                                backgroundColor: "white",
                              }}
                            >
                              <Row>
                                <Col xs="auto">
                                  <img
                                    src={data.image}
                                    className="avatar-lg"
                                    alt=""
                                    style={{
                                      borderRadius: "8px",
                                      maxWidth: "72px",
                                      maxHeight: "72px",
                                    }}
                                  />
                                </Col>
                                <Col>
                                  <Row>
                                    <Col>
                                      <strong>
                                        <span
                                          className="font-size-15 text-dark"
                                          style={{ fontWeight: 700 }}
                                        >
                                          {
                                            multiLanguageHandler(
                                              data.multiple_languages
                                            ).product_name
                                          }
                                        </span>
                                      </strong>
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col>
                                      <span className="font-size-15 text-secondary">
                                        {props.t("Qty") + ": " + data.quantity}
                                      </span>
                                    </Col>
                                    <Col className="text-end">
                                      {(orderData.order_status != "Gifted" ||
                                        orderData.member_id == uid) && (
                                        <span className="font-size-15 text-secondary">
                                          {data.currency_code +
                                            " " +
                                            data.amount}
                                        </span>
                                      )}
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                            </Card>
                          ))}
                        {orderData &&
                          (orderData.order_status != "Gifted" ||
                            orderData.member_id == uid) && (
                            <Card
                              className="mb-0 p-3 shadow-none"
                              style={{
                                borderRadius: "0px",
                                // width: "160px",
                                // height: "196px",
                                backgroundColor: "white",
                              }}
                            >
                              {/* <Row className="mb-1">
                              <Col>
                                <span>{"Quantity"}</span>
                              </Col>
                              <Col className="text-end">
                                <span>{quantity}</span>
                              </Col>
                            </Row> */}
                              <Row className="mb-1">
                                <Col>
                                  <span>{props.t("Subtotal")}</span>
                                </Col>
                                <Col className="text-end">
                                  <span>{orderData.sub_total}</span>
                                </Col>
                              </Row>
                              {/* <Row className="mb-1">
                              <Col>
                                <span>
                                  {"GST " + orderData.tax_percentage + "%"}
                                </span>
                              </Col>
                              <Col className="text-end">
                                <span>{orderData.tax}</span>
                              </Col>
                            </Row> */}
                              <Row className="mb-1">
                                <Col>
                                  <span style={{ color: "#00BB66" }}>
                                    {props.t("Discount")}
                                  </span>
                                </Col>
                                <Col className="text-end">
                                  <span style={{ color: "#00BB66" }}>
                                    {orderData.total_discount}
                                  </span>
                                </Col>
                              </Row>
                              {/* {orderData && (
                              <Row className="mb-1">
                                <Col>
                                  <span style={{ color: "#00BB66" }}>
                                    {props.t("Points")}
                                  </span>
                                </Col>
                                <Col className="text-end">
                                  <span style={{ color: "#00BB66" }}>
                                    {orderData.points}
                                  </span>
                                </Col>
                              </Row>
                            )} */}
                              <Row className="mt-3">
                                <Col>
                                  <span
                                    className="font-size-18"
                                    style={{ fontWeight: 700 }}
                                  >
                                    {props.t("Total")}
                                  </span>
                                </Col>
                                <Col className="text-end">
                                  <span
                                    className="font-size-18"
                                    style={{ fontWeight: 700 }}
                                  >
                                    {orderData.currency +
                                      " " +
                                      orderData.order_amount}
                                  </span>
                                </Col>
                              </Row>
                            </Card>
                          )}
                      </Col>
                    </Row>
                    {/* {orderData && orderData.payment_status == "Pending" && (
                      <Row className="p-3">
                        <Col>
                          <span
                            className="font-size-20 text-dark"
                            style={{ fontWeight: 500 }}
                          >
                            {"Payment Method"}
                          </span>
                        </Col>
                      </Row>
                    )} */}
                    {/* {orderData && orderData.payment_status == "Pending" && (
                      <Row>
                        <Col>
                          <Card
                            className="mb-0 p-3 shadow-none"
                            style={{
                              borderRadius: "0px",
                              // width: "160px",
                              // height: "196px",
                              backgroundColor: "white",
                            }}
                          >
                            <Row className="mb-1">
                              <Col>
                                <span>{"Stripe"}</span>
                              </Col>
                            </Row>
                          </Card>
                        </Col>
                      </Row>
                    )} */}

                    {orderData && orderData.payment_status == "Pending" && (
                      <Row
                        className="m-0 w-100"
                        style={{
                          height: "76px",
                          backgroundColor: "#ffffff",
                          position: "fixed",
                          bottom: 0,
                          zIndex: 1030,
                          maxWidth: "480px",
                          boxShadow: "0 -0.75rem 1.5rem rgba(18, 38, 63, 0.03)",
                        }}
                      >
                        <Col className="h-100 p-0">
                          <Card body className="mb-0 p-3">
                            <Row>
                              <Col>
                                <button
                                  className="btn btn-danger waves-effect waves-light font-size-18 w-100"
                                  // style={{ height: "42px" }}
                                  onClick={onClickRequestCashier}
                                >
                                  {props.t("Pay")}
                                </button>
                              </Col>
                              <Col>
                                <button
                                  className="btn btn-danger waves-effect waves-light font-size-18 w-100"
                                  // style={{ height: "42px" }}
                                  onClick={() => {
                                    setconfirm_alert(true)
                                  }}
                                >
                                  {props.t("Cancel Order")}
                                </button>
                              </Col>
                            </Row>
                          </Card>
                        </Col>
                      </Row>
                    )}
                    {orderData &&
                      orderData.payment_status == "Paid" &&
                      orderData.order_status != "Gifted" && (
                        <Row
                          className="m-0 w-100"
                          style={{
                            height: "76px",
                            backgroundColor: "#ffffff",
                            position: "fixed",
                            bottom: 0,
                            zIndex: 1030,
                            maxWidth: "480px",
                            boxShadow:
                              "0 -0.75rem 1.5rem rgba(18, 38, 63, 0.03)",
                          }}
                        >
                          <Col className="h-100 p-0">
                            <Card body className="mb-0 p-3">
                              <Row>
                                {orderData.products.length > 0 && (
                                  <Col>
                                    <button
                                      className="btn btn-danger waves-effect waves-light font-size-18 w-100"
                                      // style={{ height: "42px" }}
                                      onClick={() => {
                                        history.push(
                                          "/view-vouchers?id=" + orderData.id
                                        )
                                      }}
                                    >
                                      {props.t("View Voucher")}
                                    </button>
                                  </Col>
                                )}
                                {orderData.payment_status == "Paid" &&
                                  orderData.recipient_id == "0" &&
                                  orderData.order_status != "Self-Use" && (
                                    <Col>
                                      <button
                                        className="btn btn-danger waves-effect waves-light font-size-18 w-100"
                                        // style={{ height: "42px" }}
                                        onClick={tog_sendToFriend}
                                      >
                                        {props.t("Send to friends")}
                                      </button>
                                    </Col>
                                  )}
                              </Row>
                            </Card>
                          </Col>
                        </Row>
                      )}
                    {orderData &&
                      orderData.payment_status == "Paid" &&
                      orderData.order_status == "Gifted" &&
                      orderData.member_id != uid &&
                      orderData.products.length > 0 && (
                        <Row
                          className="m-0 w-100"
                          style={{
                            height: "76px",
                            backgroundColor: "#ffffff",
                            position: "fixed",
                            bottom: 0,
                            zIndex: 1030,
                            maxWidth: "480px",
                            boxShadow:
                              "0 -0.75rem 1.5rem rgba(18, 38, 63, 0.03)",
                          }}
                        >
                          <Col className="h-100 p-0">
                            <Card body className="mb-0 p-3">
                              <Row>
                                <Col>
                                  <button
                                    className="btn btn-danger waves-effect waves-light font-size-18 w-100"
                                    // style={{ height: "42px" }}
                                    onClick={() => {
                                      history.push(
                                        "/view-vouchers?id=" + orderData.id
                                      )
                                    }}
                                  >
                                    {props.t("View Voucher")}
                                  </button>
                                </Col>
                              </Row>
                            </Card>
                          </Col>
                        </Row>
                      )}
                    {orderData &&
                      orderData.payment_status == "Campaign Redemption" &&
                      orderData.products.length > 0 && (
                        <Row
                          className="m-0 w-100"
                          style={{
                            height: "76px",
                            backgroundColor: "#ffffff",
                            position: "fixed",
                            bottom: 0,
                            zIndex: 1030,
                            maxWidth: "480px",
                            boxShadow:
                              "0 -0.75rem 1.5rem rgba(18, 38, 63, 0.03)",
                          }}
                        >
                          <Col className="h-100 p-0">
                            <Card body className="mb-0 p-3">
                              <Row>
                                <Col>
                                  <button
                                    className="btn btn-danger waves-effect waves-light font-size-18 w-100"
                                    // style={{ height: "42px" }}
                                    onClick={() => {
                                      history.push(
                                        "/view-vouchers?id=" + orderData.id
                                      )
                                    }}
                                  >
                                    {props.t("View Voucher")}
                                  </button>
                                </Col>
                              </Row>
                            </Card>
                          </Col>
                        </Row>
                      )}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <Modal
        isOpen={modal_sendToFriend}
        toggle={() => {
          tog_sendToFriend()
        }}
      >
        <div className="modal-header">
          <span className="modal-title mt-0" id="myModalLabel">
            {props.t("Send to friends")}
          </span>
          <button
            type="button"
            onClick={() => {
              tog_sendToFriend()
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <form
            className="app-search"
            style={{ padding: 0 }}
            onSubmit={onSubmitSearchField}
          >
            <div className="position-relative">
              <input
                type="text"
                className="form-control"
                placeholder={"Search by name"}
                // value={companyvaluesearch}
                onChange={onChangeSearchField}
                style={{
                  borderRadius: "8px",
                  maxHeight: "28px",
                }}
              />
              <span
                className="bx bx-search-alt"
                style={{ lineHeight: "28px" }}
              />
            </div>
          </form>
          {friendData &&
            friendData.map((data, index) => (
              <Row>
                <Col>
                  <Card
                    className="mb-0 shadow-none"
                    style={{
                      borderRadius: "0",
                      borderBottom: "1px",
                      borderBottomColor: "#D6D6D6",
                      borderBottomStyle: "solid",
                    }}
                  >
                    <Row className="p-3">
                      <Col xs="auto">
                        {data.friend_profile_picture ? (
                          <div className="avatar-xs mx-auto">
                            <img
                              src={data.friend_profile_picture}
                              className="rounded-circle avatar-xs"
                              alt=""
                            />
                          </div>
                        ) : (
                          <div className="avatar-xs mx-auto">
                            <span
                              className={
                                "avatar-title rounded-circle bg-primary text-white font-size-16"
                              }
                            >
                              {data.friend_name && data.friend_name.charAt(0)}
                            </span>
                          </div>
                        )}
                        {/* <div className="avatar-xs mx-auto">
                                    <img
                                      src={data.friend_profile_picture}
                                      className="rounded-circle avatar-xs"
                                      alt=""
                                    />
                                  </div> */}
                      </Col>
                      <Col className="align-self-center">
                        <span className="font-size-15 text-dark">
                          {data.friend_name}
                        </span>
                      </Col>
                      <Col xs="auto">
                        <button
                          className="btn btn-primary btn-rounded btn-sm"
                          onClick={() => {
                            onClickSendOrder(data.friend_id)
                            tog_sendToFriend()
                          }}
                        >
                          <span className="font-size-14 text-white">
                            {props.t("Send")}
                          </span>
                        </button>
                      </Col>
                    </Row>
                  </Card>
                </Col>
              </Row>
            ))}
        </div>
        <div className="modal-footer">
          <Row className="pe-2">
            <button
              className="btn btn-danger waves-effect waves-light"
              // style={{ height: "42px" }}
              onClick={() => {
                handleCopy(
                  orderData.member_name +
                    " sent you an e-gift card! Click to open your gift. https://sg.ugiftglobal.com/UgiftWeb/giftcard-share?id=" +
                    oid
                )
              }}
            >
              {shareCodeMessage}
            </button>
          </Row>
          <button
            type="button"
            onClick={() => {
              tog_sendToFriend()
            }}
            className="btn btn-secondary waves-effect"
            data-dismiss="modal"
          >
            {props.t("Close")}
          </button>
          {/* <button
            type="button"
            className="btn btn-primary waves-effect waves-light"
          >
            Save changes
          </button> */}
        </div>
      </Modal>
    </React.Fragment>
  )
}

export default withTranslation()(OrderHistoryDetails)

OrderHistoryDetails.propTypes = {
  t: PropTypes.any,
}
